@if (isReady()) {
  <ng-container [formGroup]="form.get('alertsFeedSettings')">
    <div class="mb-lg">
      <label>{{ 'MAP-DISPLAY.ALERTS-FEED-WIDGET.RESPECT-LAYER-VISIBILITY' | translate }}</label>
      <topo-switch formControlName="respectLayerVisibility" />
    </div>

    <label>{{ 'MAP-DISPLAY.ALERTS-FEED-WIDGET.INCLUDED-LAYERS' | translate }}</label>
    <ng-container [formGroup]="form.get('alertsFeedSettings').get('includedLayers')">
      @for (layer of alertLayers(); track layer.uId) {
        <div class="layer-selector">
          <label class="checkbox-input remove-system-style">
            <input
              type="checkbox"
              class="checkbox-input"
              [formControlName]="layer.uId" />
            <span></span>
          </label>
          <span>{{ layer.name }}</span>
        </div>
      }
    </ng-container>
  </ng-container>
}
